'use client';

import {
    createContext as createReactContext,
    useContext as useReactContext,
} from 'react';

export interface CreateContextOptions<T> {
    name: string;
    defaultValue?: T;
}

export type CreateContextReturn<T> = [React.Provider<T>, () => T, React.Context<T>];

export function createContext<T>(options: CreateContextOptions<T>) {
    const { name, defaultValue } = options;

    const Context = createReactContext(defaultValue);

    Context.displayName = name;

    function useContext() {
        const context = useReactContext(Context);

        return context;
    }

    return [Context.Provider, useContext, Context] as CreateContextReturn<T>;
}
